let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aPemh")).then(() => parcelRequire('56Vzx'));